// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--KzJbI";
export var intro__wrap = "intro-module--intro__wrap--xOfAt";
export var intro__content = "intro-module--intro__content--1iJsR";
export var intro__boxes = "intro-module--intro__boxes--1_X72";
export var intro__boxes__box = "intro-module--intro__boxes__box--3g8B7";
export var intro__boxes__box__overlay = "intro-module--intro__boxes__box__overlay--16g1_";
export var intro__boxes__box__content = "intro-module--intro__boxes__box__content--3siVI";
export var intro__links = "intro-module--intro__links--12JvO";
export var intro__links__bg = "intro-module--intro__links__bg--1nyJ6";
export var intro__links__content = "intro-module--intro__links__content--2AGaB";